import { Volume2, VolumeX, Pause, Play, Music2 } from "lucide-react";
import { useMusic } from "@/context/MusicContext";

// Elegant, unobtrusive sound control for the Welcome / sign-in experience.
export default function SignatureSoundControl() {
  const music = useMusic();
  if (!music) return null;
  const { playing, muted, currentTime, enableWithSound, play, pause, toggleMute } = music;

  // Not playing → offer resume (from where it left off) or a first-time start.
  if (!playing) {
    const started = currentTime > 0.05;
    const onClick = () => {
      if (started) { play(); if (muted) toggleMute(); } // resume from current position
      else enableWithSound();                            // very first start, from the top
    };
    return (
      <button
        data-testid="welcome-enter-with-sound"
        onClick={onClick}
        className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2.5 rounded-full bg-[#291B2D] text-[#FCFAF6] pl-4 pr-5 py-3 text-sm font-medium shadow-[0_12px_36px_rgba(41,27,45,0.30)] hover:bg-[#352238] transition-smooth animate-fade-up"
        aria-label={started ? "Resume music" : "Enter with sound"}
      >
        <span className="relative flex h-7 w-7 items-center justify-center rounded-full bg-[#C89B55] text-[#291B2D]">
          {started ? <Play size={14} fill="currentColor" /> : <Volume2 size={15} strokeWidth={2} />}
        </span>
        {started ? "Resume music" : "Enter with sound"}
      </button>
    );
  }

  // Playing (possibly muted as an autoplay workaround) → mute/unmute + pause.
  return (
    <div
      data-testid="welcome-sound-control"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-1 rounded-full bg-[#291B2D]/95 backdrop-blur-md text-[#FCFAF6] pl-3.5 pr-2 py-2 shadow-[0_12px_36px_rgba(41,27,45,0.30)] animate-fade-up"
    >
      <span className="flex items-center gap-2 pr-1 text-xs tracking-wide text-[#FCFAF6]/80">
        <Music2 size={13} className="text-[#C89B55]" />
        <span className="hidden sm:inline">Signature playing</span>
      </span>
      <button
        data-testid="welcome-sound-mute"
        onClick={toggleMute}
        aria-label={muted ? "Unmute" : "Mute"}
        className="h-9 w-9 rounded-full flex items-center justify-center text-[#FCFAF6]/80 hover:text-[#FCFAF6] hover:bg-white/10 transition-smooth"
      >
        {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
      </button>
      <button
        data-testid="welcome-sound-pause"
        onClick={pause}
        aria-label="Pause music"
        className="h-9 w-9 rounded-full flex items-center justify-center bg-[#C89B55] text-[#291B2D] hover:bg-[#B38743] transition-smooth"
      >
        <Pause size={15} fill="currentColor" />
      </button>
    </div>
  );
}
